import styled from "styled-components";
import { ListItem } from "@8x8/oxygen-list";

export const FlexPointerContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

// FileActions.jsx

export const FullWidthListItem = styled(ListItem)`
  width: 100%;
  display: inline-flex;
`;

export const FileActionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;
